
//설정화면 라우터
const pubSettingRouter = [
     
    /* 화면명 : 영업기회 속성관리  : MCF_SC_001  */
    {
        path: "/publish/cf/MCF_SC_001", 
        name : 'PUB_MCF_SC_001',
        component: () => import('@/views/publish/cf/MCF_SC_001.vue')
    },


     /* 화면명 : 영업기회 Quota 등록 : MCF_SC_002  */
     {
        path: "/publish/cf/MCF_SC_002", 
        name : 'PUB_MCF_SC_002',
        component: () => import('@/views/publish/cf/MCF_SC_002.vue')
    },

     /* 화면명 : 영업기회 Quota 조회/수정  : MCF_SC_003  */
     {
        path: "/publish/cf/MCF_SC_003", 
        name : 'PUB_MCF_SC_003',
        component: () => import('@/views/publish/cf/MCF_SC_003.vue')
    },

     /* 화면명 : account 매핑테이블 조회/수정  : MCF_SC_004  */
     {
        path: "/publish/cf/MCF_SC_004", 
        name : 'PUB_MCF_SC_004',
        component: () => import('@/views/publish/cf/MCF_SC_004.vue')
    },

    /* 화면명 : account 매핑테이블 이력 조회  : MCF_SC_005  */
    {
        path: "/publish/cf/MCF_SC_006", 
        name : 'PUB_MCF_SC_006',
        component: () => import('@/views/publish/cf/MCF_SC_006.vue')
    },


     /* 화면명 : 사용자 조회  : MCF_US_001  */
     {
        path: "/publish/cf/MCF_US_001", 
        name : 'PUB_MCF_US_001',
        component: () => import('@/views/publish/cf/MCF_US_001.vue')
    },

     /* 화면명 : 사용자 등록  : MCF_US_002  */
     {
        path: "/publish/cf/MCF_US_002", 
        name : 'PUB_MCF_US_002',
        component: () => import('@/views/publish/cf/MCF_US_002.vue')
    },

     /* 화면명 : 부서관리  : MCF_DP_001  */
     {
        path: "/publish/cf/MCF_DP_001", 
        name : 'PUB_MCF_DP_001',
        component: () => import('@/views/publish/cf/MCF_DP_001.vue')
    },

     /* 화면명 : 화면 메뉴관리  : MCF_MN_001  */
     {
        path: "/publish/cf/MCF_MN_001", 
        name : 'PUB_MCF_MN_001',
        component: () => import('@/views/publish/cf/MCF_MN_001.vue')
    },

     /* 화면명 : 화면 권한관리 : 권한그룹  : MCF_PR_001  */
     {
        path: "/publish/cf/MCF_PR_001", 
        name : 'PUB_MCF_PR_001',
        component: () => import('@/views/publish/cf/MCF_PR_001.vue')
    },


     /* 화면명 : 사용자관리  : MCM_PR_001  */
     {
        path: "/publish/cf/MCM_PR_001", 
        name : 'PUB_MCM_PR_001',
        component: () => import('@/views/publish/cf/MCM_PR_001.vue')
    },


     /* 화면명 : 조직관리  : MCM_PR_002  */
     {
        path: "/publish/cf/MCM_PR_002", 
        name : 'PUB_MCM_PR_002',
        component: () => import('@/views/publish/cf/MCM_PR_002.vue')
    },


     /* 화면명 : 공통 코드관리  : MCF_CD_001  */
     {
        path: "/publish/cf/MCF_CD_001", 
        name : 'PUB_MCF_CD_001',
        component: () => import('@/views/publish/cf/MCF_CD_001.vue')
    },

     /* 화면명 : 배치관리  : MCF_BT_001  */
     {
        path: "/publish/cf/MCF_BT_001", 
        name : 'PUB_MCF_BT_001',
        component: () => import('@/views/publish/cf/MCF_BT_001.vue')
    },

    /* 화면명 : 알림조회  : MCF_AM_001  */
    {
        path: "/publish/cf/MCF_AM_001", 
        name : 'PUB_MCF_AM_001',
        component: () => import('@/views/publish/cf/MCF_AM_001.vue')
    },


     /* 화면명 : New&Report 등록  : MCF_NT_001  */
     {
        path: "/publish/cf/MCF_NT_001", 
        name : 'PUB_MCF_NT_001',
        component: () => import('@/views/publish/cf/MCF_NT_001.vue')
    },

     /* 화면명 : New&Report 조회  : MCF_NT_002  */
     {
        path: "/publish/cf/MCF_NT_002", 
        name : 'PUB_MCF_NT_002',
        component: () => import('@/views/publish/cf/MCF_NT_002.vue')
    }

 

]
export {pubSettingRouter}